import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ElementRef,
  ViewChild,
  AfterContentInit,
} from "@angular/core";
import { Guia } from "../../../models/Guia";
import { map, Observable, of, Subscription } from "rxjs";
import { UsuarioGuiasService } from "../../../services/data-services/usuario.guias.service";
import { UiService } from "src/app/services/ui.service";

@Component({
  selector: "app-barra-navegacao",
  templateUrl: "./barra-navegacao.component.html",
  styleUrls: ["./barra-navegacao.component.scss"],
})
export class BarraNavegacaoComponent
implements OnInit, OnDestroy, AfterContentInit {
  @ViewChild("abaLeitor") abaLeitor: ElementRef;

  public foreground: string;

  public guias$: Observable<Guia[]> = of([]);

  public indexGuiaAtiva$: Observable<number> = of(0);

  public larguraAba$: Observable<string> = of("");

  public quantidadeguia$: Observable<number> = of(0);

  public breakpointLg$: Observable<boolean> = of(false);

  private subscriptions: Subscription[] = [];

  constructor(
    private usuarioGuiasService: UsuarioGuiasService,
    private changeDetector: ChangeDetectorRef,
    private uiService: UiService
  ) {}

  ngOnInit() {
    this.usuarioGuiasService.carregar();

    this.guias$ = this.usuarioGuiasService.getGuias();

    this.indexGuiaAtiva$ = this.usuarioGuiasService.getIndexGuiaAtiva();

    this.quantidadeguia$ = this.guias$.pipe(map((guias) => guias.length));

    this.breakpointLg$ = this.uiService.getBreakpointLg();
  }

  ngAfterContentInit() {
    this.larguraAba$ = this.quantidadeguia$.pipe(
      map((aba) => {
        const laguraaba =
          (this.abaLeitor?.nativeElement?.offsetWidth - 32) / aba < 226
            ? (this.abaLeitor?.nativeElement?.offsetWidth - 32) / aba
            : 226;

        if (laguraaba < 120) {
          return `${120}px`;
        } else {
          return `${laguraaba}px`;
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];
  }

  public async alternarPara(idGuia: string) {
    await this.usuarioGuiasService.alterarGuiaAtiva(idGuia);
  }

  public fecharGuia(idGuia: string) {
    this.usuarioGuiasService.fecharGuia(idGuia);
  }
}
